export const iconFontAwesomeSciencefictionJediOrder = (
	<i className="fa-solid fa-jedi-order"></i>
);
